var map = {
	"./Webshop placeholder bloemstukken.jpg": 10172,
	"./Webshop placeholder juwelen.jpg": 2406,
	"./Webshop placeholder miniUrne.jpg": 17419,
	"./Webshop placeholder urne.jpg": 95998
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 40177;